import { productDetailService } from '@/services/product-detail.service';
import { ProductDetailDownloadSDSReq, ProductDetailQueryCoaReq } from '@/types/product-detail';
import { useQuery, useMutation } from '@tanstack/react-query';

export const useQueryProductDetail = (catalogNumber: string) => {
  return useQuery(['pdp', catalogNumber], () => productDetailService.getDetail(catalogNumber));
};

export const useQuerySDSDocumentLink = () => {
  return useMutation((req: ProductDetailDownloadSDSReq) => {
    return productDetailService.getSDSDocumentLink(req);
  });
};

export const useQueryCoaDocument = (req: ProductDetailQueryCoaReq) => {
  return useQuery({
    queryKey: ['PDP', 'COA', req],
    queryFn: async () => {
      const res = await productDetailService.getCoaInfo(req);
      return res;
    },
    keepPreviousData: true,
    enabled: !!req.sku,
  });
};
export const useQuerySpecificationSheet = (
  catalogNumber: string,
  rootCatalogNumber: string,
  shouldRefetch: boolean
) => {
  return useQuery(
    ['specification-sheet', catalogNumber, rootCatalogNumber],
    () => productDetailService.getSpecificationSheet(catalogNumber, rootCatalogNumber),
    { enabled: shouldRefetch }
  );
};

export const useQueryHoldCode = (catalogNumber: string, enabled = true) => {
  return useQuery(['hold-code', catalogNumber], () => productDetailService.getHoldCode(catalogNumber), {
    enabled: enabled,
  });
};

export const useQueryRecommendedProducts = (catalogNumber: string) => {
  return useQuery(
    ['recommended-products', catalogNumber],
    async () => {
      const res = await productDetailService.getRecommendedProducts(catalogNumber);
      return res.data;
    },
    { enabled: !!catalogNumber }
  );
};

export const useMutationStock = () => {
  return useMutation({
    mutationFn: (catalogArray: { catalogNumber: string }[]) => productDetailService.getStock(catalogArray),
  });
};
